export const Scores_InitialLeft = [
    {
        _id: '163138c29050eda2c92b598ff74da5ac',
        data: {
            value: undefined,
            valueProps: {
                color: '#FF8000',
            }
        },
    },
    {
        _id: 'caa4729b21efb44ee0edc40941aa7f6e',
        data: {
            value: undefined,
            valueProps: {
                color: '#FF8000',
            }
        },
    },
    {
        _id: '53d3d105bd032b8b26e3c51ee5845cd1',
        data: {
            value: undefined,
            valueProps: {
                color: '#FF8000',
            }
        },
    },
    {
        _id: 'cb0b0b51ceebd57eb6b60381392d528d',
        data: {
            value: undefined,
            valueProps: {
                color: '#FF8000',
            }
        },
    },
    {
        _id: '3da5e60d8df48ea8a1d10ed3437b4733',
        data: {
            valueProps: {
                color: '#FF8000',
            }
        },
    },
];
export const Scores_InitialRight = [
    {
        _id: 'BP',
        data: {
            right: undefined,
            left: undefined,
        },
    },
    {
        _id: 'ESI',
        data: {
            value: undefined,
            valueProps: {
                color: '#FF8000',
            }
        },
    },
];
export const Scores_NurseTriageEnd = [
    {
        _id: 'ESI',
        data: {
            value: '3',
            valueProps: {
                color: '#FF8000',
            }
        }
    },
    {
        _id: 'caa4729b21efb44ee0edc40941aa7f6e',
        data: {
            value: '1',
            valueProps: {
                color: '#FF8000',
            }
        }
    },
    {
        _id: 'BP',
        data: {
            left: [140, 100]
        }
    }
];
export const Scores_PhyAssessEnd = [
    {
        _id: '163138c29050eda2c92b598ff74da5ac',
        data: {
            value: '6',
            valueProps: {
                color: '#FF8000',
            }
        }
    },
    {
        _id: '3da5e60d8df48ea8a1d10ed3437b4733',
        data: {
            value: '1.5',
            valueProps: {
                color: '#FF8000',
            }
        },
    },
    {
        _id: 'caa4729b21efb44ee0edc40941aa7f6e',
        data: {
            value: '1',
            valueProps: {
                color: '#FF8000',
            }
        }
    },
];
export const Scores_hstN2Done = [
    {
        _id: '163138c29050eda2c92b598ff74da5ac',
        data: {
            value: '7',
            valueProps: {
                color: '#FF8000'
            }
        }
    }
];
export const Scores_BPDone = [
    {
        _id: 'BP',
        data: {
            left: [160, 85],
            right: [150, 90],
        }
    }
];
export const Scores_ekgAssessment2Done = [
    {
        _id: 'BP',
        data: {
            left: [120, 90],
            right: [130, 90],
        }
    }
];
//# sourceMappingURL=mock-data.js.map